module.exports = __webpack_public_path__ + "static/media/phone_gif-intro.82c355e8.gif";